import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import Grid from "@material-ui/core/Grid";
import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";
import Input from "@material-ui/core/Input";
import InputAdornment from "@material-ui/core/InputAdornment";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import MenuItem from "@material-ui/core/MenuItem";
import Paper from "@material-ui/core/Paper";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import React from "react";
import ReactDOM from "react-dom";
import {
  SelectValidator,
  TextValidator,
  ValidatorForm,
} from "react-material-ui-form-validator";
import { connect } from "react-redux";
import * as SIP from "sip.js";

import { mapActionsToProps as webrtcAction } from "../../redux/cloudPBX/dialplan";
import { mapActionsToProps as extensionAction } from "../../redux/cloudPBX/extension";
import { mapActionsToProps } from "../../redux/cloudPBX/outboundCall";
import { mapActionsToProps as indastryAction } from "../../redux/miniCrm/indastry";
import ringtone from "./../../assets/sounds/incoming.mp3";
import ringbacktone from "./../../assets/sounds/outgoing.mp3";
import DialogComponent from "./../../components/Dialog";
import datetimeHelper from "./../../helper/datetime-helper";

const styles = (theme) => ({
  root: {
    width: "100%",
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  toolbar: {
    paddingLeft: theme.spacing.unit,
  },
  formLabel: {
    // marginBottom: theme.spacing.unit * 3,
    fontSize: "1.5rem",
    fontWeight: "bold",
    alignItems: "center",
    display: "flex",
  },
  input: {
    marginTop: theme.spacing.unit * 3,
    width: "100%",
  },
  inputState: {
    marginTop: theme.spacing.unit * 3,
  },
  form: {
    width: "100%",
  },
  paper: {
    marginBottom: theme.spacing.unit * 3,
  },
  snackbar: {
    margin: theme.spacing.unit,
  },
});

const SESSION_STATUS = {
  IDLE: 9,
  OUTBOUND_STARTING: 1,
  OUTBOUND_RINGING: 2,
  INBOUND_RINGING: 4,
  ANSWERING: 12,
};

class DialButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
    };
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
  }
  handleMouseDown(e) {
    this.setState({ active: true });
  }
  handleMouseUp(e) {
    if (this.state.active) {
      this.setState({ active: false });
    }
  }
  componentDidMount() {
    const element = ReactDOM.findDOMNode(this.refs.button);
    element.addEventListener("mousedown", this.handleMouseDown);
    window.addEventListener("mouseup", this.handleMouseUp);
  }
  componentWillUnmount() {
    const element = ReactDOM.findDOMNode(this.refs.button);
    element.removeEventListener("mousedown", this.handleMouseDown);
    window.removeEventListener("mouseup", this.handleMouseUp);
  }
  render() {
    const { symbol, alias, icon, compact, color } = this.props;
    const { active } = this.state;
    return (
      <p
        ref="button"
        style={{
          borderWidth: "1px",
          borderStyle: "solid",
          borderColor: "#4d4d4d #000 #000 #4d4d4d",
          color: "#fff",
          fontSize: "20px",
          padding: "15px",
          margin: 0,
          textAlign: "center",
          backgroundColor: active ? "#00caf2" : color ? color : "transparent",
          height: "30px",
        }}>
        <strong>
          {icon}
          {(!icon || !compact) && <span>&nbsp;{symbol}</span>}
        </strong>
        {/* {!!alias && !compact && (
                    <sup style={{
                        'textTransform': 'uppercase',
                        'color': '#c1c1c1',
                        'fontSize': '60%'
                    }}>{alias}</sup>
                )} */}
      </p>
    );
  }
}

export class DialPad extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { onClick, compact } = this.props;
    const buttons = [
      {
        symbol: "1",
      },
      {
        symbol: "2",
        alias: "abc",
      },
      {
        symbol: "3",
        alias: "def",
      },
      {
        symbol: "4",
        alias: "ghi",
      },
      {
        symbol: "5",
        alias: "jkl",
      },
      {
        symbol: "6",
        alias: "mno",
      },
      {
        symbol: "7",
        alias: "pqrs",
      },
      {
        symbol: "8",
        alias: "tuv",
      },
      {
        symbol: "9",
        alias: "wxyz",
      },
      {
        symbol: <Icon>call</Icon>,
        action: "call",
        color: "green",
      },
      {
        symbol: "0",
      },
      {
        symbol: <Icon>call_end</Icon>,
        action: "hangup",
        color: "red",
      },
    ];
    return (
      <div ref="container">
        <div
          style={{
            float: "left",
            display: "block",
            width: "100%",
            WebkitTouchCallout: "none",
            WebkitUserSelect: "none",
            KhtmlUserSelect: "none",
            MozUserSelect: "none",
            MsUserSelect: "none",
            userSelect: "none",
            background: "#1d1918",
            fontFamily: '"Lucida Grande", Tahoma, Arial, Verdana, sans-serif',
          }}>
          <ol
            style={{
              margin: 0,
              padding: 0,
              listStyle: "none",
            }}>
            {buttons.map((button, i) => (
              <li
                onClick={() => onClick(button)}
                style={{
                  float: "left",
                  cursor: "pointer",
                  width: "calc(100%/3)",
                }}
                key={i}>
                <DialButton {...button} compact={compact} />
              </li>
            ))}
          </ol>
        </div>
      </div>
    );
  }
}

DialPad.defaultProps = {
  onClick: () => {},
};

function TabContainer(props) {
  return <React.Fragment>{props.children}</React.Fragment>;
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class Dial extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      capture: true,
      compact: false,
      userId: "qc482g",
      password: "xktear",
      phoneNumber: "0982491026",
      modal: false,
      session: null,
      disable: false,
      disablePhone: true,
      status: null,
      phoneTransfer: "",
      callStatus: "",
      callPhone: "",
      callDuration: "",
      callType: "",
      callId: "",
      tabs: 0,
      checkAnswer: false,
    };
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleResize = this.handleResize.bind(this);
  }
  handleTranferCall = () => {
    const { session } = this.state;
    session.refer(this.state.phoneTransfer, () => {
      console.log("demo");
    });
  };
  isCompact() {
    const container = ReactDOM.findDOMNode(this.refs.container);
    return container ? container.getBoundingClientRect().width < 540 : false;
  }
  handleResize(e) {
    const { compact } = this.state;
    if (this.isCompact()) {
      if (!compact) {
        this.setState({ compact: true });
      }
    } else {
      if (compact) {
        this.setState({ compact: false });
      }
    }
  }

  handleClickToCall = () => {
    const { session, ua } = this.state;
    const phone = this.props.phone.toString().replace(/[^0-9]/g, "");
    this.setState({ modal: true });
    let status = SESSION_STATUS.IDLE;
    if (session) {
      status = session.status;
    }
    const callSession = ua.invite(phone, {
      media: {
        constraints: {
          audio: true,
          video: false,
        },
      },
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: true,
          video: false,
        },
      },
    });
    callSession.type = "outbound";
    callSession.on("accepted", function () {
      console.log("ACCEPTED");
    });
    callSession.on("rejected", function () {
      console.log("REJECTED");
    });
    callSession.on("cancel", function () {
      console.log("CANCEL");
    });
    callSession.on("failed", function () {
      console.log("FAILED");
    });
    callSession.on("bye", function () {
      console.log("BYE");
    });

    callSession.on("trackAdded", function () {
      console.log("TRACK_ADDED");
      var pc = callSession.sessionDescriptionHandler.peerConnection;
      var player = document.getElementById("player");
      var remoteStream = new MediaStream();

      pc.getReceivers().forEach(function (receiver) {
        remoteStream.addTrack(receiver.track);
      });

      if (typeof player.srcObject !== "undefined") {
        player.srcObject = remoteStream;
      } else if (typeof player.mozSrcObject !== "undefined") {
        player.mozSrcObject = remoteStream;
      } else if (typeof player.src !== "undefined") {
        player.src = URL.createObjectURL(remoteStream);
      } else {
        console.log("Error attaching stream to element.");
      }
      player.play();
    });
    this.setState({ session: callSession });
  };

  handleClick(button) {
    const { ua, value, session, tabs } = this.state;
    if (tabs == 2) {
      button = button.toString().replace(/[^0-9]/g, "");
      this.setState({ modal: true });
      let status = SESSION_STATUS.IDLE;
      if (session) {
        status = session.status;
      }
      const callSession = ua.invite(button, {
        media: {
          constraints: {
            audio: true,
            video: false,
          },
        },
        sessionDescriptionHandlerOptions: {
          constraints: {
            audio: true,
            video: false,
          },
        },
      });
      callSession.type = "outbound";
      callSession.on("accepted", function () {
        console.log("ACCEPTED");
      });
      callSession.on("rejected", function () {
        console.log("REJECTED");
      });
      callSession.on("cancel", function () {
        console.log("CANCEL");
      });
      callSession.on("failed", function () {
        console.log("FAILED");
      });
      callSession.on("bye", function () {
        console.log("BYE");
      });

      callSession.on("trackAdded", function () {
        console.log("TRACK_ADDED");
        var pc = callSession.sessionDescriptionHandler.peerConnection;
        var player = document.getElementById("player");
        var remoteStream = new MediaStream();

        pc.getReceivers().forEach(function (receiver) {
          remoteStream.addTrack(receiver.track);
        });

        if (typeof player.srcObject !== "undefined") {
          player.srcObject = remoteStream;
        } else if (typeof player.mozSrcObject !== "undefined") {
          player.mozSrcObject = remoteStream;
        } else if (typeof player.src !== "undefined") {
          player.src = URL.createObjectURL(remoteStream);
        } else {
          console.log("Error attaching stream to element.");
        }
        player.play();
      });
      this.setState({ session: callSession });
    } else if (!button.action) {
      this.setState({
        value: `${value}${button.symbol}`,
      });
    } else if ("call" === button.action) {
      this.setState({ modal: true });
      let status = SESSION_STATUS.IDLE;
      if (session) {
        status = session.status;
      }
      const callSession = ua.invite(value, {
        media: {
          constraints: {
            audio: true,
            video: false,
          },
        },
        sessionDescriptionHandlerOptions: {
          constraints: {
            audio: true,
            video: false,
          },
        },
      });
      callSession.type = "outbound";
      callSession.on("accepted", function () {
        console.log("ACCEPTED");
      });
      callSession.on("rejected", function () {
        console.log("REJECTED");
      });
      callSession.on("cancel", function () {
        console.log("CANCEL");
      });
      callSession.on("failed", function () {
        console.log("FAILED");
      });
      callSession.on("bye", function () {
        console.log("BYE");
      });

      callSession.on("trackAdded", function () {
        console.log("TRACK_ADDED");
        var pc = callSession.sessionDescriptionHandler.peerConnection;
        var player = document.getElementById("player");
        var remoteStream = new MediaStream();

        pc.getReceivers().forEach(function (receiver) {
          remoteStream.addTrack(receiver.track);
        });

        if (typeof player.srcObject !== "undefined") {
          player.srcObject = remoteStream;
        } else if (typeof player.mozSrcObject !== "undefined") {
          player.mozSrcObject = remoteStream;
        } else if (typeof player.src !== "undefined") {
          player.src = URL.createObjectURL(remoteStream);
        } else {
          console.log("Error attaching stream to element.");
        }
        player.play();
      });
      this.setState({ session: callSession });
    } else if ("hangup" === button.action) {
      if (session) {
        session.terminate();
      }
      this.setState({ modal: false, disable: false });
    }
  }

  handleCallEnter = (e) => {
    const { ua, value, session } = this.state;
    if (e.key === "Enter") {
      this.setState({ modal: true });
      let status = SESSION_STATUS.IDLE;
      if (session) {
        status = session.status;
      }
      const callSession = ua.invite(value, {
        media: {
          constraints: {
            audio: true,
            video: false,
          },
        },
        sessionDescriptionHandlerOptions: {
          constraints: {
            audio: true,
            video: false,
          },
        },
      });
      callSession.type = "outbound";
      callSession.on("accepted", function () {
        console.log("ACCEPTED");
      });
      callSession.on("rejected", function () {
        console.log("REJECTED");
      });
      callSession.on("cancel", function () {
        console.log("CANCEL");
      });
      callSession.on("failed", function () {
        console.log("FAILED");
      });
      callSession.on("bye", function () {
        console.log("BYE");
      });

      callSession.on("trackAdded", function () {
        console.log("TRACK_ADDED");
        var pc = callSession.sessionDescriptionHandler.peerConnection;
        var player = document.getElementById("player");
        var remoteStream = new MediaStream();

        pc.getReceivers().forEach(function (receiver) {
          remoteStream.addTrack(receiver.track);
        });

        if (typeof player.srcObject !== "undefined") {
          player.srcObject = remoteStream;
        } else if (typeof player.mozSrcObject !== "undefined") {
          player.mozSrcObject = remoteStream;
        } else if (typeof player.src !== "undefined") {
          player.src = URL.createObjectURL(remoteStream);
        } else {
          console.log("Error attaching stream to element.");
        }
        player.play();
      });
      this.setState({ session: callSession });
    }
  };
  handleKeyPress(e) {
    const { capture, value } = this.state;
    if (!capture) {
      return;
    }
    switch (e.charCode) {
      case 48:
      case 49:
      case 50:
      case 51:
      case 52:
      case 53:
      case 54:
      case 55:
      case 56:
      case 57:
      case 42:
      case 43:
        this.setState({
          value: value + String.fromCharCode(e.charCode),
        });
        break;
      default:
        break;
    }
  }
  soundRingtone = new Audio(ringtone);
  soundRingbacktone = new Audio(ringbacktone);
  componentDidMount() {
    window.addEventListener("keypress", this.handleKeyPress);
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.handleCheckStatus();
    this.handleRegister();
    this.props.getListIndastry();
    this.interval = setInterval(() => {
      return this.handleCheckStatus();
    }, 1000);
    this.props.getListExtension(null, null, null, null, { include: ["pbx"] });
    if (this.props.phone) {
      console.log(this.props.phone);
    }
  }
  componentWillUnmount() {
    window.removeEventListener("keypress", this.handleKeyPress);
    window.removeEventListener("resize", this.handleResize);
    clearInterval(this.interval);
  }

  handleCheckStatus = () => {
    const { session } = this.state;
    if (session) {
      switch (session.status) {
        case SESSION_STATUS.IDLE: {
          this.setState({
            callStatus: "",
            callPhone: "",
            callDuration: "",
            callType: "",
            callId: "",
            openIboundCall: false,
            modal: false,
            checkAnswer: false,
          });
          break;
        }
        case SESSION_STATUS.ANSWERING: {
          this.setState({
            callStatus: "Đang trả lời",
            callPhone: session.remoteIdentity.uri.normal.user,
            callDuration: Math.floor((new Date() - session.startTime) / 1000),
            callType:
              session.type === "inbound" ? "cuộc gọi vào" : "cuộc gọi ra",
            callId: session.id,
            callName: session.request.from.displayName,
          });
          break;
        }
        case SESSION_STATUS.OUTBOUND_RINGING: {
          this.setState({
            callStatus: "Đang đổ chuông",
            callPhone: session.remoteIdentity.uri.normal.user,
            callType:
              session.type === "inbound" ? "Cuộc gọi vào" : "Cuộc gọi ra",
            callId: session.id,
            openIboundCall: false,
            modal: true,
            callName: session.request.from.displayName,
          });
          this.soundRingbacktone.play();
          break;
        }
        case SESSION_STATUS.INBOUND_RINGING: {
          this.setState({
            callStatus: "Đang gọi ...",
            callPhone: session.remoteIdentity.uri.normal.user,
            callType:
              session.type === "inbound" ? "Cuộc gọi vào" : "Cuộc gọi ra",
            callId: session.id,
            callDuration: Math.floor((new Date() - session.startTime) / 1000),
            openIboundCall: true,
            callName: session.request.from.displayName,
            checkAnswer: false,
          });
          this.soundRingtone.play();
          break;
        }
        default:
          break;
      }
    }
  };

  beginCapture(e) {
    this.setState({
      capture: true,
    });
  }
  endCapture(e) {
    this.setState({
      capture: false,
    });
  }
  reset() {
    this.setState({
      value: "",
    });
  }
  handleChange(e) {
    this.setState({
      value: e.target.value,
    });
  }
  handleChangeInput = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };
  handleRegister = () => {
    const config = new SIP.UA({
      uri: `sip:snbph9@wss-dev.api-connect.io`,
      authorizationUser: `snbph9`,
      password: `string`,
      register: true,
      transportOptions: {
        wsServers: [`wss://wss-dev.api-connect.io:8089/wss`],
      },
      usePreloadedRoute: true,
      media: {
        constraints: {
          audio: true,
          video: false,
        },
      },
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: true,
          video: false,
        },
      },
    });
    config.on("connected", () => {
      return this.setState({ status: 1 });
    });
    config.on("registered", () => {
      return this.setState({ status: 2 });
    });
    config.on("unregistered", () => {
      return this.setState({ status: 3 });
    });
    config.on("error", function (error) {
      console.log("ERROR", error);
    });
    config.on("invite", (s) => {
      this.setState({ session: s, openIboundCall: true });
      s.type = "inbound";
      s.on("accepted", function () {
        console.log("ACCEPTED");
      });
      s.on("rejected", function () {
        console.log("REJECTED");
      });
      s.on("cancel", function () {
        console.log("CANCEL");
      });
      s.on("failed", function () {
        console.log("FAILED");
      });
      s.on("bye", function () {
        console.log("BYE");
      });

      s.on("trackAdded", function () {
        console.log("TRACK_ADDED");
        var pc = s.sessionDescriptionHandler.peerConnection;
        var player = document.getElementById("player");
        var remoteStream = new MediaStream();
        pc.getReceivers().forEach(function (receiver) {
          remoteStream.addTrack(receiver.track);
        });
        if (typeof player.srcObject !== "undefined") {
          player.srcObject = remoteStream;
        } else if (typeof player.mozSrcObject !== "undefined") {
          player.mozSrcObject = remoteStream;
        } else if (typeof player.src !== "undefined") {
          player.src = URL.createObjectURL(remoteStream);
        } else {
          console.log("Error attaching stream to element.");
        }
        player.play();
      });
    });
    config.start();
    this.setState({ ua: config, disable: true });
  };

  handleEndCall = () => {
    this.state.session.terminate();
    this.setState({
      modal: false,
      disable: false,
      openIboundCall: false,
      checkAnswer: false,
      modelDialer: false,
    });
  };

  handleChangeTabs = (event, tabs) => {
    this.setState({ tabs }, () => {
      if (tabs == 1) {
        this.props.getListExtension(null, null, null, null, {
          include: ["pbx"],
        });
      } else if (tabs == 2) {
        this.props.getList("createdAt DESC", 20, 0, null);
      }
    });
  };

  handleAnswerCall = () => {
    const { session } = this.state;
    let option = {
      sessionDescriptionHandlerOptions: {
        constraints: {
          audio: true,
          video: false,
        },
      },
    };
    if (session.status === SESSION_STATUS.INBOUND_RINGING) {
      session.accept(option);
      this.setState({ checkAnswer: true });
    }
  };

  handleSaveCustomer = () => {
    const { name, email, phoneNumber, address, note } = this.state;
    this.props.addNewAccount(name, email, phoneNumber, address, note);
    setTimeout(
      function () {
        this.setState({ modalSave: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  render() {
    const {
      tabs,
      value,
      compact,
      openIboundCall,
      callName,
      status,
      phoneTransfer,
      callStatus,
      callPhone,
      callDuration,
      callType,
      name,
      email,
      phoneNumber,
      address,
      note,
      website,
      industryId,
    } = this.state;
    const { classes, logOutBound, listExtension, listIndastry } = this.props;
    const logOutBoundResult =
      typeof logOutBound === "object"
        ? Object.keys(logOutBound).map((key) => logOutBound[key])
        : logOutBound;
    const listExtensionResult =
      typeof listExtension === "object"
        ? Object.keys(listExtension).map((key) => listExtension[key])
        : listExtension;
    const listIndastryResult =
      typeof listIndastry === "object"
        ? Object.keys(listIndastry).map((key) => listIndastry[key])
        : listIndastry;
    return (
      <React.Fragment>
        <audio id="player" autoPlay></audio>
        <React.Fragment>
          <Paper square className={classes.root}>
            <Tabs
              value={tabs}
              onChange={this.handleChangeTabs}
              indicatorColor="primary"
              textColor="primary"
              variant="standard">
              <Tab
                icon={<Icon>dialpad</Icon>}
                label="Bàn phím"
                style={{ minWidth: 115 }}
              />
              <Tab
                icon={<Icon>person</Icon>}
                label="Danh bạ"
                style={{ minWidth: 115 }}
              />
              <Tab
                icon={<Icon>compare_arrows</Icon>}
                label="Cuộc gọi"
                style={{ minWidth: 115 }}
              />
            </Tabs>
            <Divider />
          </Paper>
          {tabs === 0 && (
            <TabContainer>
              <div style={{ maxWidth: "100%", margin: "0 auto" }}>
                <Input
                  style={{
                    fontSize: "30px",
                    minHeight: "47px",
                    backgroundColor: "#fff",
                    color: "#000",
                    width: "100%",
                  }}
                  onChange={this.handleChange.bind(this)}
                  onFocus={this.endCapture.bind(this)}
                  onBlur={this.beginCapture.bind(this)}
                  autoFocus
                  onKeyPress={this.handleCallEnter}
                  type="number"
                  value={value}
                  variant="outlined"
                  endAdornment={
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={this.reset.bind(this)}>
                        {!!value && (
                          <Icon style={{ color: "#000" }}>clear</Icon>
                        )}
                      </IconButton>
                    </InputAdornment>
                  }
                />
                <DialPad
                  onClick={this.handleClick.bind(this)}
                  compact={compact}
                />
              </div>
            </TabContainer>
          )}
          {tabs === 2 && (
            <TabContainer>
              <List dense={false}>
                {logOutBoundResult
                  ? logOutBoundResult.map((item, key) => {
                      return (
                        <React.Fragment key={key}>
                          <ListItem>
                            <ListItemAvatar>
                              <Icon style={{ color: "#fff" }}>person</Icon>
                            </ListItemAvatar>
                            <ListItemText
                              primary={item.to}
                              secondary={datetimeHelper.toFormat(
                                item.startedAt,
                                "YYYY-MM-DD HH:mm:ss"
                              )}
                            />
                            <ListItemSecondaryAction>
                              <IconButton
                                aria-label="call"
                                onClick={this.handleClick.bind(this, item.to)}>
                                <Icon>call</Icon>
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                          <Divider />
                        </React.Fragment>
                      );
                    })
                  : null}
              </List>
            </TabContainer>
          )}
          {tabs === 1 && (
            <TabContainer>
              <List dense={false}>
                {listExtensionResult
                  ? listExtensionResult.map((item, key) => {
                      return (
                        <React.Fragment key={key}>
                          <ListItem>
                            <ListItemAvatar>
                              <Icon style={{ color: "#fff" }}>person</Icon>
                            </ListItemAvatar>
                            <ListItemText
                              primary={item.username}
                              secondary={item.name}
                            />
                            <ListItemSecondaryAction>
                              <IconButton
                                aria-label="call"
                                onClick={this.handleClick.bind(this, item.to)}>
                                <Icon>call</Icon>
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                          <Divider />
                        </React.Fragment>
                      );
                    })
                  : null}
              </List>
            </TabContainer>
          )}
        </React.Fragment>
        {status != null ? (
          <Dialog
            open={this.state.modal}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description">
            <DialogTitle id="alert-dialog-title">
              Thông tin cuộc gọi
            </DialogTitle>
            <Divider />
            <ValidatorForm
              ref="form"
              onSubmit={this.handleTranferCall}
              onError={(errors) => console.log(errors)}>
              <React.Fragment>
                <DialogContent>
                  <DialogContentText>
                    <Typography variant="body2" gutterBottom>
                      {" "}
                    </Typography>
                  </DialogContentText>
                  <DialogContent>
                    <DialogContentText>
                      <Typography variant="body2" gutterBottom>
                        Họ tên: {callName}
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        Số điện thoại: {callPhone}
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        Loại cuộc gọi: {callType}
                      </Typography>
                      <Typography variant="body2" gutterBottom>
                        Trạng thái: {callStatus}
                      </Typography>
                      <Typography variant="body2">
                        Thời lượng:{" "}
                        {callDuration
                          ? datetimeHelper.secondToHHMMSS(callDuration)
                          : "00:00:00"}
                      </Typography>
                    </DialogContentText>
                  </DialogContent>
                  <Divider />
                  <FormControl className={classes.form}>
                    <FormGroup>
                      <TextValidator
                        variant="outlined"
                        className={classes.input}
                        label="Số điện thoại chuyển tiếp"
                        onChange={this.handleChangeInput("phoneTransfer")}
                        name="phoneTransfer"
                        value={phoneTransfer}
                        fullWidth
                        validators={["required", "matchRegexp:^[0-9]+$"]}
                        errorMessages={[
                          `Không được để trống`,
                          "Số điện thoại không hợp lệ",
                        ]}
                      />
                    </FormGroup>
                  </FormControl>
                </DialogContent>
                <DialogActions>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    autoFocus>
                    Chuyển tiếp cuộc gọi
                  </Button>
                  <Button
                    onClick={this.handleEndCall}
                    color="secondary"
                    autoFocus>
                    Kết thúc cuộc gọi
                  </Button>
                </DialogActions>
              </React.Fragment>
            </ValidatorForm>
          </Dialog>
        ) : null}
        <Snackbar
          open={openIboundCall}
          anchorOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          onClose={this.handleClose}>
          <SnackbarContent
            className={classes.snackbar}
            message={
              <React.Fragment>
                <Typography
                  variant="body2"
                  style={{ color: "#000" }}
                  gutterBottom>
                  Họ tên: {callName}
                </Typography>
                <Typography
                  variant="body2"
                  style={{ color: "#000" }}
                  gutterBottom>
                  Số điện thoại: {callPhone}
                </Typography>
                <Typography
                  variant="body2"
                  style={{ color: "#000" }}
                  gutterBottom>
                  {callDuration
                    ? `Thời lượng: ${datetimeHelper.secondToHHMMSS(
                        callDuration
                      )}`
                    : `Trạng thái: ${callStatus}`}
                </Typography>
                {this.state.checkAnswer == true ? (
                  <Grid container>
                    <Grid item md={6}>
                      <Tooltip
                        title="Chuyển tiếp cuộc gọi"
                        aria-label="Chuyển tiếp cuộc gọi">
                        <IconButton
                          variant="contained"
                          color="primary"
                          style={{ marginRight: 10 }}
                          className={classes.button}
                          onClick={() => this.setState({ modalTranfer: true })}>
                          <Icon>call_split</Icon>
                        </IconButton>
                      </Tooltip>
                    </Grid>
                    <Grid item md={6}>
                      <Tooltip
                        title="Lưu thông tin khách hàng"
                        aria-label="Lưu thông tin khách hàng">
                        <IconButton
                          variant="contained"
                          color="primary"
                          style={{ marginRight: 10 }}
                          className={classes.button}
                          onClick={() => this.setState({ modalSave: true })}>
                          <Icon>save</Icon>
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                ) : null}
              </React.Fragment>
            }
            action={
              <React.Fragment>
                {this.state.checkAnswer != true ? (
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "green",
                      color: "#fff",
                      marginRight: 10,
                    }}
                    className={classes.button}
                    onClick={this.handleAnswerCall}>
                    <Icon>call</Icon>
                  </Button>
                ) : null}
                <Button
                  variant="contained"
                  color="secondary"
                  className={classes.button}
                  onClick={() => this.state.session.terminate()}>
                  <Icon>call_end</Icon>
                </Button>
              </React.Fragment>
            }
          />
        </Snackbar>

        <Dialog
          open={this.state.modalTranfer}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">
            Chuyển tiếp cuộc gọi
          </DialogTitle>
          <ValidatorForm
            ref="form"
            onSubmit={this.handleTranferCall}
            onError={(errors) => console.log(errors)}>
            <React.Fragment>
              <DialogContent>
                <FormControl className={classes.form}>
                  <FormGroup>
                    <TextValidator
                      variant="outlined"
                      className={classes.input}
                      label="Số điện thoại chuyển tiếp"
                      onChange={this.handleChangeInput("phoneTransfer")}
                      name="phoneTransfer"
                      value={phoneTransfer}
                      fullWidth
                      validators={["required", "matchRegexp:^[0-9]+$"]}
                      errorMessages={[
                        `Không được để trống`,
                        "Số điện thoại không hợp lệ",
                      ]}
                    />
                  </FormGroup>
                </FormControl>
              </DialogContent>
              <DialogActions>
                <Button
                  type="submit"
                  color="primary"
                  variant="contained"
                  autoFocus>
                  Chuyển tiếp
                </Button>
                <Button
                  onClick={() => this.setState({ modalTranfer: false })}
                  color="secondary"
                  autoFocus>
                  Hủy
                </Button>
              </DialogActions>
            </React.Fragment>
          </ValidatorForm>
        </Dialog>
        <DialogComponent
          open={this.state.modalSave}
          title={"Thêm khách hàng"}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleSaveCustomer}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Tên khách hàng"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeInput("name")}
                    value={name}
                    name="name"
                    validators={["required"]}
                    emptyLabel="Không được để trống"
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Email"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeInput("email")}
                    value={email}
                    name="email"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>email</Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Số điện thoại"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeInput("phoneNumber")}
                    value={callPhone}
                    name="phoneNumber"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>phone</Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Địa chỉ"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeInput("address")}
                    value={address}
                    name="address"
                    validators={["required"]}
                    errorMessages="Không được để trống"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>location_on</Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Website"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeInput("website")}
                    value={website}
                    name="website"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Icon>public</Icon>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <SelectValidator
                    id="outlined-full-width"
                    margin="normal"
                    select
                    SelectProps={{
                      MenuProps: {
                        className: classes.menu,
                        shrink: true,
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    label="Nghề nghiệp"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeInput("industryId")}
                    value={industryId}
                    name="industryId"
                    validators={["required"]}
                    errorMessages={"Không được để trống"}>
                    {listIndastryResult
                      ? listIndastryResult.map((item) => {
                          return (
                            <MenuItem key={item.id} value={item.id}>
                              {item.name}
                            </MenuItem>
                          );
                        })
                      : null}
                  </SelectValidator>
                  <TextValidator
                    id="outlined-full-width"
                    margin="normal"
                    label="Ghi chú"
                    variant="outlined"
                    className={classes.input}
                    onChange={this.handleChangeInput("note")}
                    value={note}
                    name="note"
                    multiline
                    rows={5}
                    validators={["required"]}
                    errorMessages="Không được để trống"
                  />
                </Grid>
                <DialogActions>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.button}>
                    Lưu
                  </Button>
                  <Button
                    onClick={() => this.setState({ modalSave: false })}
                    color="secondary"
                    className={classes.button}>
                    Hủy
                  </Button>
                </DialogActions>
              </FormControl>
            </ValidatorForm>
          }
          onClose={() => this.setState({ modalSave: false })}
        />
      </React.Fragment>
    );
  }
}

Dial.propTypes = {
  classes: PropTypes.object.isRequired,
  userId: PropTypes.string,
  password: PropTypes.string,
  hostname: PropTypes.string,
  port: PropTypes.string,
  path: PropTypes.string,
  phone: PropTypes.string,
  handleCallManual: PropTypes.func,
};

const mapStateToProps = (state) => ({
  logOutBound: state.outBoundCall.outBound,
  listExtension: state.extension.extensions,
  listIndastry: state.indastry.indastries,
});

const ExtensionAction = connect(null, extensionAction)(Dial);
const Indastry = connect(null, indastryAction)(ExtensionAction);
const WebRtc = connect(null, webrtcAction)(Indastry);
Dial = connect(mapStateToProps, mapActionsToProps)(WebRtc);

export default withStyles(styles)(Dial);
